export const loadBase64Preview = (file: File) => {
    return new Promise(resolve => {
        console.log(file);
        const fileReader = new FileReader();
        fileReader.addEventListener("load", event => {
            resolve(event.target.result);
        });

        fileReader.readAsDataURL(file);
    });
};

export const getExt = (fileName: string) => {
    if (!fileName) {
        return "";
    }
    const ext = fileName.split(".");
    const extname = ext[ext.length - 1].toLowerCase();

    if (extname.includes("%")) {
        const [finalExt] = extname.split("%");
        return finalExt;
    }

    return extname;
};

export const findFilenameOnUrl = (url: string) => {
    if (!url) {
        return url;
    }

    const name = url?.split("/")?.pop()?.split("?")?.[0];
    return decodeURIComponent(name);
};
